<template>
  <div class="table-responsive">
    <table class="table table-condensed table-bordered">
      <thead>
        <tr>
          <th>ID</th>
          <th>Monto</th>
          <th>Saldo</th>
          <th>Puede pagar</th>
          <th>Cancelado</th>
          <th>Pagar/Cancelar</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td> {{getInscripcion.matricula.id}} </td>
          <td> {{getInscripcion.matricula.monto}} Bs.</td>
          <td> {{getInscripcion.matricula.saldo}} Bs.</td>
          <td> {{getInscripcion.matricula.puede_pagar?'SI':'NO'}} </td>
          <td> {{getInscripcion.matricula.cancelado?'SI':'NO'}} </td>
          <td> <button class="btn btn-sm btn-azul" @click="beforePagarMatricula(getInscripcion.matricula)" :disabled="getInscripcion.matricula.cancelado" data-toggle="modal" data-target="#modal-matricula">Registrar pago</button> </td>
        </tr>
      </tbody>
    </table>

    <div class="modal fade" tabindex="-1" role="dialog" id="modal-matricula">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
            <h4 class="modal-title text-center"> Registrar Pago de matricula </h4>
          </div>
          <div class="modal-body"> <PagarMatricula :id="pagarMatricula.id" :matri="pagarMatricula" :listener="listener"/> </div>
          <div class="modal-footer"> <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button> </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PagarMatricula from '@/components/AM.vue'
export default {
  props:{ getInscripcion:{type:Object,required:true},listener:{type:Object,required:true} },
  data(){
    return{
      pagarMatricula:{ id:-1 },
    }
  },
  components:{ PagarMatricula },
  methods:{
    beforePagarMatricula( mat ){ this.pagarMatricula=mat; },
  },
}
</script>